<template>
  <a
    :href="href"
    @click.prevent="handleLink"
    :class="linkClass"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'Link',
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
    href: {
      type: String,
      required: true,
    },
    router: {
      type: Boolean,
      default: () => true,
    },
    target: {
      type: String,
    },
  },
  methods: {
    handleLink() {
      if (this.disabled) {
        return;
      }

      if (this.target) {
        window.open(this.href, this.target);
        return;
      }

      if (!this.router) {
        window.location.href = this.href;
        return;
      }

      this.$router.push(this.href);
    },
  },
  computed: {
    linkClass() {
      return {
        link: true,
        disabled: this.disabled,
      };
    },
  },
};
</script>
